// extracted by mini-css-extract-plugin
module.exports = {"cursor":"ReloveIconPhotos_cursor__2jtZh","root":"ReloveIconPhotos_root__1LMrO"};